import {
  LOCALIDAD_SUCCESS,
  LOCALIDAD_LOADING,
  LOCALIDAD_ERROR,
  LOCALIDAD_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

export const localidad = () => (dispatch) => {
  dispatch({
    type: LOCALIDAD_LOADING,
  });

 axiosLogin().then(respuesta => {
  respuesta
  .get(`/shared/Localidades`)
  .then((res) => {
    dispatch({
      type: LOCALIDAD_SUCCESS,
      payload: res.data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
    };

    dispatch({
      type: LOCALIDAD_ERROR,
      payload: error,
    });
  });
 } )
};

// export const localidad = () => (dispatch) => {
//   dispatch({
//     type: LOCALIDAD_LOADING,
//   });

//  axiosInstance().then(respuesta => {
//   respuesta
//   .get(`/localidades`)
//   .then((res) => {
//     dispatch({
//       type: LOCALIDAD_SUCCESS,
//       payload: res.data,
//     });
//   })
//   .catch((err) => {
//     let error = {
//       detail: err.response
//         ? err.response.data
//         : "Error al contactar el server.",
//     };

//     dispatch({
//       type: LOCALIDAD_ERROR,
//       payload: error,
//     });
//   });
//  } )
// };

export const localidadReset = () => (dispatch) => {
  dispatch({
    type: LOCALIDAD_RESET,
  });
};
